import { initForm } from 'landings/__assets__/scripts/components/form-handling-competition'

initForm({ requireRegisteredEmail: false })
